import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@affinite/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DialogTaskComponent } from './dialog-task.component';
import { DirectivesModule } from '../../../directive/directives.module';
import { VdtDatepickerModule } from "@affinite/common";
import { PipesModule } from '@affinite/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    DirectivesModule,
    VdtDatepickerModule,
    PipesModule
],
  declarations: [
    DialogTaskComponent
  ],
  exports: [
    DialogTaskComponent
  ]
})
export class DialogTaskModule { }
